<template>
  <div
    class="Collapsable"
    :class="{ 'delayed-overflow': isOpen }"
    :aria-expanded="isOpen"
    :style="{ '--content-height': `${contentHeight}px` }"
  >
    <div ref="collapsable">
      <slot :open="isOpen" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useElementBounding, useVModel } from '@vueuse/core';

interface Props {
  open: boolean;
}

const props = defineProps<Props>();

const collapsable = ref<HTMLElement | null>(null);

const emit = defineEmits(['update:open']);
const isOpen = useVModel(props, 'open', emit, { passive: true });
const { height: contentHeight } = useElementBounding(collapsable);
</script>

<style>
:root {
  --content-height: 0;
  --speed-slow: 0.3s;
}

.Collapsable {
  transition: max-height var(--speed-slow);
  max-height: 0;
  overflow-y: hidden;
}

.delayed-overflow {
  overflow-y: visible;
  animation: 1s delay-overflow;
}
@keyframes delay-overflow {
  from { overflow-y: hidden; }
}

.Collapsable[aria-expanded="true"] {
  max-height: var(--content-height);
}
</style>
